<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6">
                <el-button icon="el-icon-download" @click="download">{{$t('common.export')}}</el-button>
            </el-col>
            <el-col :span="6">
                <product-selector v-model="filter.productId" :placeholder="$t('common.product')"></product-selector>
            </el-col>
            <el-col :span="6">
                <resolution-category-selector v-model="filter.categoryId" :productId="filter.productId"></resolution-category-selector>
            </el-col>
            <el-col :span="6">
                <el-input v-model="filter.description" placeholder="$t('common.description')"></el-input>
            </el-col>
        </el-row>

        <el-table size="mini" :data="codes" v-loading="loading" class="tablewithshading">
            <el-table-column prop="code" :label="$t('common.code')" width="80"></el-table-column>
            <el-table-column prop="description" :label="$t('common.description')"></el-table-column>
            <el-table-column prop="model" :label="$t('common.model')"></el-table-column>
            <el-table-column prop="category" :label="$t('common.category')"></el-table-column>
            <el-table-column prop="labor" :label="$t('common.labor')" width="80"></el-table-column>
            <el-table-column prop="maxTime" :label="$t('common.maxTime')" width="80"></el-table-column>
            
        </el-table>
        <el-pagination class="pager" v-if="total !== 0"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="15"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
    </div>
</template>

<script>
import {
  ProductSelector,
  ResolutionCategorySelector
} from "@/app/shared/components";
import api from "../api";
import axios from "axios";

export default {
  name: "price-list-report",
  components: {
    ProductSelector,
    ResolutionCategorySelector
  },
  data() {
    return {
      loading: false,
      codes: [],
      filter: {
        productId: undefined,
        categoryId: undefined,
        description: undefined
      },
      currentPage: 1,
      total: 0
    };
  },
  created() {
    this.loadCodes();
  },
  watch: {
    filter: {
      deep: true,
      handler: function(val) {
        this.currentPage = 1;
        this.loadCodes();
      }
    },
    "filter.productId": function() {
      this.filter.categoryId = undefined;
    }
  },
  methods: {
    loadCodes() {
      this.loading = true;
      api.getCodes(this.currentPage, this.filter).then(response => {
        this.loading = false;
        this.codes = response.data.items;
        this.total = response.data.total;
      });
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadCodes();
    },
    download() {
      api.download(this.filter);
    }
  }
};
</script>


// WEBPACK FOOTER //
// ClientApp/app/reports/components/ResolutionCodeList.vue